import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Slider.css';
import './SliderCustom.css';
import '../../../styles/tools/nucleo/icons.css';
import '../../../styles/tools/nucleo/nucleo.css';
import ReactSlider from 'react-slick';
import Fonz1 from './fonz1.png';
import PrevArrow from "./prevArrow/PrevArrow.jsx";
import NextArrow from "./nextArrow/NextArrow.jsx";

/**
 * Slider - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Slider extends Component {

    /**
     * Default props
     *
     * @type {{}}
     */
    static defaultProps = {
        settings: {
            dots: true,
            infinite: true,
            initialSlide: 6,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <NextArrow/>,
            prevArrow: <PrevArrow/>
        },
        data: [
            {
                type: 'video',
                url: 'https://www.youtube.com/watch?v=-c6UajZLBW4'
            },
            {
                type: 'text',
                text: 'Hello World',
                author: 'Joe Jones'
            },
            {
                type: 'image',
                src: Fonz1
            }
        ],
        index: 0
    };

    state = {
        settings: {}
    };

    /**
     * Prop Types
     *
     * @type {{}}
     */
    static propTypes = {
        settings: PropTypes.object,
        data: PropTypes.array.isRequired,
        index: PropTypes.number
    };


    /**
     * Component did mount
     */
    componentDidMount() {
        const {index, settings} = this.props;

        settings.initialSlide = index;

        this.setState({
            settings: settings
        })
    }


    /**
     * Render
     *
     * @returns {XML}
     */
    render() {

        const {closeModalPopup, data, settings} = this.props;

        let dataMapped = data.map(function (item, index, data) {

            let counter = "(" + (index + 1) + "/" + data.length + ")"

            return <div key={index}
                        className="SliderItem">
                <header>
                    <h2>{item.title}</h2>
                     {/**<p>{item.description}</p>*/}
                    <p dangerouslySetInnerHTML={{__html: item.description}}></p>
                </header>
                <article>
                    <div className="SliderItem__col1">
                        <img src={item.imageLarge}
                             alt=""/>
                    </div>
                    <div className="SliderItem__col2">
                        <h3>Ingredients</h3>

                        <p dangerouslySetInnerHTML={{__html: item.ingredients}}></p>

                        {item.Allergens ?
                            <div>
                            <h5>Allergens</h5> 
                            <p>{item.Allergens}</p></div> :
                            ''}
                        
                        <img className="SliderItem__label"
                             src={item.ingredientsImage}
                             alt=""/>

                    </div>
                </article>
                <div className="SliderItem__counter"><h3>{counter}</h3></div>
            </div>
        });

        return (
            <div>
                <button onClick={closeModalPopup}>close</button>
                <ReactSlider {...settings}>
                    {dataMapped}
                </ReactSlider>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/global/slider/Slider.jsx